import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Icon, { LeftOutlined } from "@ant-design/icons";
import { Button, Input, notification } from "antd";
import Header from "../../components/layout/header";
import Styles from "./registerTrolleyError.module.scss";
import { LeftIcon } from "../../assets/icons/icons";

const RegisterTrolleyError = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const trolleyId = searchParams.get("trolleyId") || "";
  const [mdu, setMdu] = useState<string>("");
  const [mduError, setMduError] = useState<string>("");

  // Restore form values from sessionStorage on mount
  useEffect(() => {
    const STORAGE_KEY = `registerTrolleyFormData_${trolleyId}`;
    try {
      const savedData = sessionStorage.getItem(STORAGE_KEY);
      if (savedData) {
        const parsed = JSON.parse(savedData);
        if (parsed.mdu) setMdu(parsed.mdu);
      }
    } catch (error) {
      console.warn("Failed to restore form data from sessionStorage", error);
    }
  }, [trolleyId]);

  const handleContinue = () => {
    const trimmedMdu = mdu.trim();
    
    // Validate MDU is required
    if (!trimmedMdu) {
      setMduError("MDU is required");
      notification.error({
        message: "MDU Required",
        description: "Please enter MDU to continue",
        duration: 3,
      });
      return;
    }

    // Clear any previous errors
    setMduError("");

    // Save form data to sessionStorage before navigating
    const STORAGE_KEY = `registerTrolleyFormData_${trolleyId}`;
    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          mdu: trimmedMdu,
        })
      );
    } catch (error) {
      console.warn("Failed to save form data to sessionStorage", error);
    }

    // Encode the ID in query parameter to handle special characters
    const params = new URLSearchParams({
      trolleyId: trolleyId,
      mdu: trimmedMdu,
    });
    navigate(`/register-trolley-review?${params.toString()}`);
  };

  const handleBack = () => {
    navigate("/operator-landing");
  };

  return (
    <div className={Styles.mainContainer}>
      <Header />
      <div className={Styles.contentContainer}>
        <div className={Styles.header}>
          <Icon component={LeftIcon} onClick={handleBack} />
          <h2 className={Styles.title}>Register Trolley</h2>
        </div>

        <div className={Styles.errorSection}>
          <div className={Styles.errorMessage}>
            The Trolley (ID: {trolleyId}) isn't registered in our system.
          </div>

          <div className={Styles.promptMessage}>
            Would you like to create a new trolley record using this code?
          </div>

          <div className={Styles.inputSection}>
            <label className={Styles.inputLabel}>Trolley ID</label>
            <Input readOnly value={trolleyId} className={Styles.inputField} allowClear />
          </div>

          <div className={Styles.inputSection} style={{ marginTop: "20px" }}>
            <label className={Styles.inputLabel}>
              MDU <span style={{ color: "#ff4d4f" }}>*</span>
            </label>
            <Input 
              value={mdu}
              onChange={(e) => {
                setMdu(e.target.value);
                // Clear error when user starts typing
                if (mduError) {
                  setMduError("");
                }
              }}
              className={Styles.inputField}
              placeholder="Enter MDU"
              allowClear
              status={mduError ? "error" : ""}
              enterKeyHint="done"
              onPressEnter={(e) => e.currentTarget.blur()}
            />
            {mduError && (
              <div style={{ color: "#ff4d4f", fontSize: "12px", marginTop: "4px" }}>
                {mduError}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={Styles.fixedButtonWrapper}>
        <Button
          className={Styles.continueButton}
          size="large"
          onClick={handleContinue}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};

export default RegisterTrolleyError;
